<template>
  <v-snackbar v-model="snackbar.show" :color="snackbar.color" :top="true" :bottom="false" :left="false" :right="false" :multi-line="true" :timeout="5000" :vertical="false">
    {{ snackbar.text }}
    <v-btn dark flat @click="hideSnackbar()">Entendi</v-btn>
  </v-snackbar>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'snackbar',
  computed: mapState('UI', ['snackbar']),
  methods: mapMutations('UI', ['hideSnackbar']),
}
</script>



// WEBPACK FOOTER //
// src/components/Snackbar.vue